import { render, staticRenderFns } from "./DialogFormManufacturerAdd.vue?vue&type=template&id=62b4ae72"
import script from "./DialogFormManufacturerAdd.vue?vue&type=script&lang=js"
export * from "./DialogFormManufacturerAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports